import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import accountNameStandardised from "../../../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";

const TaxationMultiApprovalSuccess = () => {
  // 1️⃣ useNavigate
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 2️⃣ useState
  const [successPageData, setsuccessPageData] = useState([]);
  const [successPageID, setsuccessPageID] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);
  const [approvedTransactions, setApprovedTransactions] = useState([]);

  // 3️⃣ Callback / Handler functions
  const goToDashboard = () => {
    navigate("/tax_transaction_dashboard");
  };

  const approveMoreTransactions = () => {
    navigate("/tax_transaction_dashboard/tax_transaction_multi_select");
  };

  const buttonRows = [
    [
      {
        btnText: "Approve more transactions",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: approveMoreTransactions,
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  // 4️⃣ useEffect
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedTaxData"),
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];
      const pending = transactions.filter(
        (transaction) => transaction.lifecycle_status === "pending",
      );
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved",
      );
      setsuccessPageData(storedSelectedApproval?.selectedSendTransactions);
      setPendingTransactions(pending);
      setApprovedTransactions(approved);
      setsuccessPageID(storedSelectedApproval.selectedTransactions);
    } else {
      setsuccessPageData([]);
      setsuccessPageID([]);
    }
  }, []);
  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const renderAccountRow = (account, useStandardised = true) => ({
    leftTitle: useStandardised
      ? accountNameStandardised(account?.tds_account_name)
      : account?.tds_account_name
          ?.toLowerCase()
          .split(" ")
          .map(
            (w) =>
              w.charAt(GlobalConfiguration.lengthCheckZero).toUpperCase() +
              w.slice(GlobalConfiguration.lengthCheckOne),
          )
          .join(" "),
    leftSubTitle: "Account name",
    rightTitleTextColor: "var(--text-primary)",
    rightTextFontWeight: "semibold",
    hasRight: true,
    rightIcon: true,
    rightText: true,
    rightTitle: `INR ${FormatAmount({ price: account?.amount })}`,
    rightSubTitle: "Amount",
    onClick: () =>
      navigate(
        `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${account?.txn_id}`,
      ),
  });
  return (
    <>
      {" "}
      <div>
        {" "}
        <StatusContainer
          status="success"
          title={
            successPageData.length && "Transactions approved successfully "
          }
          buttonRows={buttonRows}
        >
          {approvedTransactions.length >
            GlobalConfiguration.lengthCheckZero && (
            <TabsWeapperSection
              title={`Distribution created  - ${successPageID.length}`}
            >
              <div className="flex flex-col">
                {successPageData.map((account, i) => (
                  <InfoCard
                    key={account?.txn_id || i}
                    bgColor="var(--positive-card)"
                    hoverable="white"
                    onClick={() =>
                      navigate(
                        `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${account?.txn_id}`,
                      )
                    }
                    rows={[{ ...renderAccountRow(account) }]}
                  />
                ))}
              </div>
            </TabsWeapperSection>
          )}

          {pendingTransactions.length > GlobalConfiguration.lengthCheckZero && (
            <TabsWeapperSection
              title={`Pending  - ${pendingTransactions.length}`}
            >
              <div className="flex flex-col">
                {successPageData.map((account, i) => (
                  <InfoCard
                    key={account?.txn_id || i}
                    bgColor="var(--positive-card)"
                    hoverable="white"
                    onClick={() =>
                      navigate(
                        `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${account?.txn_id}`,
                      )
                    }
                    rows={[{ ...renderAccountRow(account, false) }]}
                  />
                ))}
              </div>
            </TabsWeapperSection>
          )}

          {pendingTransactions.length > GlobalConfiguration.lengthCheckZero &&
            approvedTransactions.length >
              GlobalConfiguration.lengthCheckZero && (
              <>
                <TabsWeapperSection
                  title={`Distribution created   - ${approvedTransactions?.length}`}
                >
                  <div className="flex flex-col">
                    {successPageData.map((account, i) => (
                      <InfoCard
                        key={account?.txn_id || i}
                        bgColor="var(--positive-card)"
                        hoverable="white"
                        onClick={() =>
                          navigate(
                            `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${account?.txn_id}`,
                          )
                        }
                        rows={[{ ...renderAccountRow(account, false) }]}
                      />
                    ))}
                  </div>
                </TabsWeapperSection>
                <TabsWeapperSection
                  title={`Pending  - ${pendingTransactions?.length}`}
                >
                  <div className="flex flex-col">
                    {successPageData.map((account, i) => (
                      <InfoCard
                        key={account?.txn_id || i}
                        bgColor="var(--positive-card)"
                        hoverable="white"
                        onClick={() =>
                          navigate(
                            `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${account?.txn_id}`,
                          )
                        }
                        rows={[{ ...renderAccountRow(account, false) }]}
                      />
                    ))}
                  </div>
                </TabsWeapperSection>
              </>
            )}
        </StatusContainer>
      </div>
    </>
  );
};

export default TaxationMultiApprovalSuccess;
